import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Box, Button, TextField, Typography } from '@mui/material';
import { IoClose } from "react-icons/io5";
import { useState } from 'react';
import SnackBar from '../../General/SnackBar';
import { CompletePayment } from 'API/PaymentOrder/api';
import { useEffect } from 'react';

const CalculateAmount = (params) => {
    const totalAmount = params && params.quantity && Array.isArray(params.quantity)
        ? params.quantity.reduce((sum, item) => {
            if (item.price) {
                return parseFloat((sum + item.price) * 1.00);
            }
            return parseFloat(sum * 1.00);
        }, 0)
        : 0;

    console.log("totalAmount ", totalAmount);
    return params && params.purchase_order_details && params.purchase_order_details.tax_type === "interstate" ?
        parseInt(totalAmount + parseInt(params.updated_tax.igst)).toFixed(2)
        :
        params ?
            parseInt(totalAmount + parseInt(params.updated_tax.cgst) + parseInt(params.updated_tax.sgst)).toFixed(2)
            :
            ""
};


export default function CompletePaymentDialog(props) {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
    const [Data, setData] = useState({ payment_order_id: props.data?._id, payment_date: "", total_amount: CalculateAmount(props.PaymentType === "create" ? props.data : props.viewData), amount_paid:eval( CalculateAmount(props.PaymentType === "create" ? props.data : props.viewData)-props.data?.tds), tds: `${props.data&&props.data.tds?props.data.tds:"0"}`, utr: "" })
    const [AlertMessage, setAlertMessage] = useState("")
    const [AlertType, setAlertType] = useState("")
    const [OpenAlert, setOpenAlert] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    // console.log("props", props);



    const handleAlertOpen = (message, type) => {
        setAlertMessage(message)
        setAlertType(type)
        setOpenAlert(true)

    }

    const handleAlertClose = () => {
        setOpenAlert(false)
    }

    // console.log("Data",props.data?.tds);
    

    // console.log(eval(CalculateAmount(props.PaymentType === "create" ? props.data : props.viewData)-(props.data?.tds||props.viewData?.tds)));
    

    useEffect(() => {
        setData({ ...Data, total_amount: CalculateAmount(props.PaymentType === "create" ? props.data : props.viewData) ,tds: `${props.PaymentType === "create"?props.data&&props.data.tds?props.data.tds:"0":props.viewData&&props.viewData.tds?props.viewData.tds:"0"}`,amount_paid:eval(CalculateAmount(props.PaymentType === "create" ? props.data : props.viewData)-(props.data&&props.data.tds?props.data.tds:props.viewData&&props.viewData.tds||"0")).toFixed(2) })
    }, [props])

    useEffect(() => {
        if (!props.open) {
            setData({ payment_order_id: props.data?._id, payment_date: formattedDate, total_amount: CalculateAmount(props.PaymentType === "create" ? props.data : props.viewData), amount_paid: "", tds: `${props.data&&props.data.tds?props.data.tds:"0"}`, utr: "" })
        }
    }, [props.open])


    const handleDataChange = (field, value) => {
        if (field === 'amount_paid' || field === 'total_amount') {
            // Allow only numeric values with up to 2 decimal places or empty input
            const isValidNumber = /^\d*(\.\d{0,2})?$/.test(value);
    
            if (isValidNumber || value === "") {
                // Convert empty input to 0 for numeric fields
                const numericValue = value === "" ? "" : value;
    
                if (field === 'amount_paid' && parseFloat(numericValue) > parseFloat(Data.total_amount || 0)) {
                    return; // Ignore invalid input when amount_paid exceeds total_amount
                }
    
                setData({ ...Data, [field]: numericValue});
            }
        } 
        else if (field === 'payment_date') {
            setData({ ...Data, [field]: value });
        } else {
            // Allow alphanumeric values with a maximum length of 30
            if (/^[0-9A-Za-z]*$/.test(value) && value.length <= 30) {
                setData({ ...Data, [field]: value.toUpperCase() });
            }
        }
    };
    
    
    // 


    const handleSubmit = () => {
        console.log("Post", (parseFloat(Data.amount_paid)+parseFloat(Data.tds)),Data);

        if (Data.payment_date === "" || Data.total_amount === "" || Data.amount_paid === "" || Data.tds === "" || Data.utr === "") {
            handleAlertOpen("Please fill all the fields", "error")
            return
        }
        else if ((parseFloat(Data.amount_paid)) > parseFloat(Data.total_amount)) {
            handleAlertOpen("Amount paid cannot be more than total amount", "error")
            return
        }
        else {

            CompletePayment(Data, props.data._id, setIsLoading, handleAlertOpen)
        }
    }


    //  const handleSubmit=()=>{
    //     CompletePayment({})
    //  }

    return (
        <React.Fragment>
            <SnackBar message={AlertMessage} open={OpenAlert} type={AlertType} handleClose={handleAlertClose} />
            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="sm"
            >
                <Box sx={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer', fontSize: '24px' }} onClick={props.handleClose}>
                    <IoClose />
                </Box>

                <DialogContent>
                    <table style={{ width: '80%' }}>
                        <tr>
                            <td style={{ padding: '10px' }}>
                                <Typography variant="h5">Date of payment</Typography>
                            </td>
                            <td style={{ padding: '10px' }}>
                                <TextField
                                    type='date'
                                    value={props.PaymentType === 'create' ? Data.payment_date : props.open ? props.viewData.payment_date : ""}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        max: formattedDate,
                                        readOnly: props.PaymentType === 'view' ? true : false
                                    }}

                                    onKeyDown={e => e.preventDefault()}
                                    onChange={(e) => handleDataChange('payment_date', e.target.value)}
                                    id="standard-basic"
                                    variant="standard" />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px' }}>
                                <Typography variant="h5">Total Amount</Typography>
                            </td>
                            <td style={{ padding: '10px' }}>
                                <TextField
                                    type='text'
                                    value={Data.total_amount ? Data.total_amount : ''}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    
                                    inputProps={
                                        {
                                            readOnly: true
                                        }
                                    }
                                    onChange={(e) => handleDataChange('total_amount', e.target.value)}
                                    id="standard-basic"
                                    variant="standard" />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px' }}>
                                <Typography variant="h5">Amount Paid</Typography>
                            </td>
                            <td style={{ padding: '10px' }}>
                                <TextField
                                    type='text'
                                    value={props.PaymentType === 'create' ? Data.amount_paid ? Data.amount_paid : '' : props.open ? props.viewData.amount_paid : ""}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={
                                        {
                                            readOnly: true 
                                        }
                                    }
                                    onChange={(e) => handleDataChange('amount_paid', e.target.value)}
                                    id="standard-basic"
                                    variant="standard" />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px' }}>
                                <Typography variant="h5">TDS</Typography>
                            </td>
                            <td style={{ padding: '10px' }}>
                                <TextField
                                    value={ props.open && 
                                       ( Data.tds || Data.tds<1) ? `${Data.tds}` : "0"}
                                    type='text'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={
                                        {
                                            readOnly:  true 
                                        }
                                    }
                                    fullWidth
                                    onChange={(e) => handleDataChange('tds', e.target.value)}
                                    id="standard-basic"
                                    variant="standard" />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px' }}>
                                <Typography variant="h5">UTR</Typography>
                            </td>
                            <td style={{ padding: '10px' }}>
                                <TextField
                                    value={props.PaymentType === 'create' ? Data.utr ? Data.utr : '' : props.open ? props.viewData.utr : ""}
                                    type='text'
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={
                                        {
                                            readOnly: props.PaymentType === 'view' ? true : false
                                        }
                                    }
                                    onChange={(e) => handleDataChange('utr', e.target.value)}
                                    id="standard-basic"
                                    variant="standard" />
                            </td>
                        </tr>
                    </table>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
                    {
                        props.PaymentType === 'create' ?
                            <Button size='small' color='secondary' disabled={isLoading} variant='contained' onClick={() => handleSubmit()} autoFocus>
                                {isLoading ? "Loading" : "SUBMIT"}
                            </Button>
                            :
                            null

                    }

                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
